import frameQuickRuleImg from '@assets/web-v3-images/FrameQuickRule.png';
import { Text } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import RuleContent from '@/component/RuleContent';

export default function QuickRule({ data }) {
	const { t } = useTranslation()

	return (
		<div
			className="relative w-full aspect-[1080/450] mb-5 mt-4"
			style={{
				backgroundImage: `url(${frameQuickRuleImg})`,
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'top center',
				backgroundSize: '100% 100%',
			}}
		>
			<Text className="absolute left-1/2 top-[13%] -translate-x-1/2 -translate-y-1/2 text-[15px] sm:text-[25px] font-bold text-[#7A2E0E]">
				{data?.title}
			</Text>
			<div
				className="
					absolute
					left-[5%]
					right-[18%]
					top-[60%]
					-translate-y-1/2
					h-[70%]
					flex
					items-center
  			"
			>
				<div
					className="w-[75%] max-h-full overflow-y-auto pr-2 hide-scrollbar scrollbar-h-2
										scrollbar-thin
										scrollbar-thumb-[#E6B97D]
										scrollbar-track-transparent"
				>
					<RuleContent
						content={data?.content || ""}
						className="text-left text-[#542314] text-[14px] md:text-[23px] font-medium"
					/>
				</div>
			</div>
		</div>
	);
}
